<template>
  <b-modal
    id="customer_modal"
    ref="customer_modal"
    title="Place Order As Guest"
    hide-footer
    size="lg"
  >
    <b-container>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <b-form @submit.prevent="handleSubmit(create_customer)">
          <b-row class="justify-content-center">
            <div class="col-md-6 col-sm-12 border-right">
              <h5 class="text-purple">Customer Details</h5>

              <label class="text-secondary">Enter Name</label>
              <ValidationProvider
                name="name"
                rules="required"
                v-slot="{ errors, failed }"
              >
                <b-form-input
                  v-model="customer.name"
                  :class="failed ? 'error-input' : 'form-input'"
                ></b-form-input>
                <span class="form-error">{{ errors[0] }}</span>
              </ValidationProvider>

              <br/>
              <label class="text-secondary">Enter Email</label>
              <ValidationProvider
                name="email"
                rules="required|email"
                v-slot="{ errors, failed }"
              >
                <b-form-input
                  v-model="customer.email"
                  type="email"
                  :class="failed ? 'error-input' : 'form-input'"
                ></b-form-input>
                <span class="form-error">{{ errors[0] }}</span>
              </ValidationProvider>

              <br/>
              <label class="text-secondary">Enter Contact</label>
              <ValidationProvider
                name="contact"
                rules="required"
                v-slot="{ errors, failed }"
              >
                <b-form-input
                  v-model="customer.contact"
                  type="tel"
                  :class="failed ? 'error-input' : 'form-input'"
                ></b-form-input>
                <span class="form-error">{{ errors[0] }}</span>
              </ValidationProvider>

              <ValidationObserver v-if="member_checked">
                <br/>
                <label class="text-secondary">Enter Password</label>
                <ValidationProvider
                  name="password"
                  rules="required|min:6|password:@confirm"
                  v-slot="{ errors, failed }"
                >
                  <b-form-input
                    v-model="customer.password"
                    type="password"
                    :class="failed ? 'error-input' : 'form-input'"
                  ></b-form-input>
                  <span class="form-error">{{ errors[0] }}</span>
                </ValidationProvider>

                <br/>
                <label class="text-secondary">Confirm Password</label>
                <ValidationProvider
                  name="password confirmation"
                  rules="required|min:6"
                  vid="confirm"
                  v-slot="{ errors, failed }"
                >
                  <b-form-input
                    v-model="customer.password_confirmation"
                    type="password"
                    :class="failed ? 'error-input' : 'form-input'"
                  ></b-form-input>
                  <span class="form-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </ValidationObserver>

              <b-form-checkbox
                id="password-checkbox"
                v-model="member_checked"
                name="password-checkbox"
                :value="true"
                :unchecked-value="false"
                class="mb-2"
              >
                Create account
              </b-form-checkbox>
            </div>

            <div class="col-md-6 col-sm-12">
              <h5 class="text-purple">Delivery Address</h5>

              <div class="row">
                <div class="col-md-12">
                  <label
                    v-if="currentRestaurant.coverage_type == 'areas'"
                    class="text-secondary"
                  >Select Area</label>

                  <label
                    v-else
                    class="text-secondary"
                  >Search Place</label>

                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors, failed }"
                  >

                    <b-form-select
                      v-if="currentRestaurant.coverage_type == 'areas'"
                      v-model="area"
                      :options="coverageAreaOptions"
                      :class="failed ? 'error-input' : 'form-input mb-4'"
                    ></b-form-select>

                    <vue-bootstrap-typeahead
                      v-else
                      :data="places"
                      v-model="query"
                      :serializer="s => s.text"
                      :class="failed ? 'error-input' : 'form-input'"
                    />

                    <span class="form-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <label class="text-secondary">Enter Street</label>
                  <ValidationProvider
                    name="street"
                    rules="required"
                    v-slot="{ errors, failed }"
                  >
                    <b-form-input
                      v-model="customer.addresses_attributes[0].street"
                      :class="failed ? 'error-input' : 'form-input'"
                    ></b-form-input>
                    <span class="form-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>

                <div class="col-md-6">
                  <label class="text-secondary">Enter Building</label>
                  <ValidationProvider
                    name="building"
                    rules="required"
                    v-slot="{ errors, failed }"
                  >
                    <b-form-input
                      v-model="customer.addresses_attributes[0].building"
                      :class="failed ? 'error-input' : 'form-input'"
                    ></b-form-input>
                    <span class="form-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>

              <label class="text-secondary">Enter Floor</label>
              <ValidationProvider
                name="floor"
                rules="required"
                v-slot="{ errors, failed }"
              >
                <b-form-input
                  v-model="customer.addresses_attributes[0].floor"
                  :class="failed ? 'error-input' : 'form-input'"
                ></b-form-input>
                <span class="form-error">{{ errors[0] }}</span>
              </ValidationProvider>

              <ValidationProvider rules="required" v-slot="{ failed }">
                <br/>
                <label class="text-secondary">Address For</label><span class="form-error">{{ failed ? '1 required' : ''}}</span>
                <b-form-radio v-model="customer.addresses_attributes[0].address_type" value="home">Home</b-form-radio>
                <b-form-radio v-model="customer.addresses_attributes[0].address_type" value="office">Office</b-form-radio>
              </ValidationProvider>
            </div>
          </b-row>

          <b-row class="justify-content-center">
            <b-col class="col-md-2 col-sm-12">
              <b-button
                type="submit"
                squared
                variant="outline-primary"
                class="my-2"
              >Complete</b-button>
            </b-col>
          </b-row>
        </b-form>
      </ValidationObserver>

      <div class="border-bottom my-2"></div>
      <div class="text-right">
        <p>Already member? <router-link class="text-purple" to="/login">Login</router-link></p>
      </div>
    </b-container>
  </b-modal>
</template>

<script>
import TextInput from '../components/text_input'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import _ from 'underscore'
import { mapGetters } from 'vuex'

const API_URL = `https://api.foursquare.com/v2/venues/suggestcompletion?ll=:lat,:lng&query=:query&client_id=${process.env.VUE_APP_FOURSQUARE_CLIENT_ID}&client_secret=${process.env.VUE_APP_FOURSQUARE_CLIENT_SECRET}`

export default {
  components: {
    'text-input': TextInput,
    'vue-bootstrap-typeahead': VueBootstrapTypeahead,
  },

  data() {
    return {
      member_checked: false,
      customer: {
        name: '',
        email: '',
        contact: '',
        password: '',
        password_confirmation: '',
        addresses_attributes: [{
          area: '',
          street: '',
          building: '',
          floor: '',
          address_type: '',
        }],
      },
      area: '',
      query: '',
      places: [],
      currentLocation: {},
    }
  },

  created() {
    this.$store.dispatch('getRestaurant')
    if (navigator.geolocation)
      navigator.geolocation.getCurrentPosition(
        response => { this.currentLocation = response.coords },
        error => { alert('Allow to access your location.') }
      )
  },

  computed: {
    ...mapGetters(['currentRestaurant']),
    coverageAreaOptions() {
      return this.currentRestaurant.coverage_areas.map((coverageArea, index) => {
        return {
          value: coverageArea.name,
          text: coverageArea.name
        }
      })
    },
  },

  methods: {
    create_customer() {
      if (this.currentRestaurant.coverage_type == 'areas')
        this.customer.addresses_attributes[0].area = this.area
      else
        this.customer.addresses_attributes[0].area = this.query
      this.$store.dispatch('customer_signup', this.customer)
        .then(response => {
          this.$store.dispatch('place_order', {
            order_id: $cookies.get('order_id'),
            cart: {
              status: 1,
              customer_id: response.data.data.id,
              address_id: response.data.data.attributes.addresses[0].id,
            }
          })
            .then(response => {
              this.$refs['customer_modal'].hide()
              $cookies.remove('order_id')
              this.$store.commit("update_cart", '')
              this.$notify({
                type: 'success',
                text: 'Your order has been placed successfully.'
              })
            })
        })
        .catch(error => {
          this.$refs.form.setErrors(error.data.errors)
          console.log(error)
        })
    },
    async fetchPlaces(query) {
      const result = await fetch(this.getApiUrl(query))
      const suggestions = await result.json()
      this.places = suggestions.response.minivenues.map((minivenue) => {
        if (minivenue.location.address != undefined)
          return { text: `${minivenue.name}, ${minivenue.location.city}` }
        else
          return { text: minivenue.name }
      })
    },
    getApiUrl(query) {
      return API_URL.replace(':query', query).replace(':lat', this.currentLocation.latitude).replace(':lng', this.currentLocation.longitude)
    },
  },

  watch: {
    query: _.debounce(function(searchQuery) {
      if (searchQuery != "")
        this.fetchPlaces(searchQuery)
    }, 500)
  },
}
</script>

<style scoped>
  .btn-outline-primary {
    color: #5663FF;
    border-color: #5663FF;
    background-color: white;
    box-shadow: none;
  }
  .btn-outline-primary:hover {
    color: white;
    border-color: #5663FF;
    background-color: #5663FF;
  }
  .text-purple {
    color: #5663FF;
  }
  .form-error {
    color: #D9534F;
    padding: 5px;
  }
  .error-input {
    border:1px solid #D9534F;
  }
</style>
